import React, { useEffect } from "react";
import HeroHeader from "../components/Home/HeroHeader";
import ResultsSection from "../components/Home/ResultsSection";
import TeamSection from "../components/Home/TeamSection";
import TechnologySection from "../components/Home/TechnologySection";
import ServicesSection from "../components/Home/ServicesSection";
import WhyChoose from "../components/Home/WhyChoose"
import LocationSection from "../components/Home/LocationSection";
import ContactCTA from "../components/Home/ContactCTA";
import Navbar from "../components/Home/Navbar";
import Footer from "../components/Home/Footer";

const LandingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "DobleDx | Transformamos tu marca";
  }, []);

  return (
    <div>
      <Navbar />
      <HeroHeader />
      <ResultsSection />
      <TeamSection />
      <TechnologySection />
      <ServicesSection />
      <WhyChoose />
      <LocationSection />
      <ContactCTA />
      <Footer />
    </div>
  );
};

export default LandingPage;
